import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthAllapot.tsx';
import { supabase } from '../lib/supabase.ts';
import { Gomb, HibaUzenet, Kartya, Mezo } from '../ui/elemek.tsx';

const MAX = 4000;

export default function JegyzetUrlap({ leadId, officeId }: { leadId: string; officeId: string }) {
  const { session } = useAuth();
  const qc = useQueryClient();
  const [szoveg, setSzoveg] = useState('');
  const mentes = useMutation({
    mutationFn: async () => {
      const { error } = await supabase.from('lead_esemenyek').insert({
        lead_id: leadId, office_id: officeId, tipus: 'jegyzet', adat: { szoveg: szoveg.trim() }, szerzo: session?.user.id ?? null,
      });
      if (error) throw error;
    },
    onSuccess: async () => {
      setSzoveg('');
      await qc.invalidateQueries({ queryKey: ['esemenyek', leadId] });
    },
  });
  const ervenyes = szoveg.trim().length >= 1 && szoveg.length <= MAX;
  function bekuld(e: FormEvent) {
    e.preventDefault();
    if (ervenyes) mentes.mutate();
  }
  return (
    <Kartya>
      <form onSubmit={bekuld} className="grid gap-3">
        <Mezo label="Új jegyzet" multiline value={szoveg} maxLength={MAX} onChange={(e) => setSzoveg(e.target.value)}
          suly={`${szoveg.length} / ${MAX}`} />
        <HibaUzenet hiba={mentes.error} />
        <Gomb type="submit" toltes={mentes.isPending} disabled={!ervenyes}>Jegyzet mentése</Gomb>
      </form>
    </Kartya>
  );
}
